 <template>
    <el-select
        @change="SelectChange"
        v-model="selectValue"
        :style="{ width: width, margin: margin }"
        size="mini"
        placeholder="省份"
        no-data-text="请选择先国家或区域"
        clearable>
        <el-option v-for="(item, idx) in select" :key="idx" :label="item.name" :value="item.name"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Array],
            default: null
        },
        country: {
            type: String,
            default: null
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
    },
    watch: {
        value () {
            this.selectValue = this.value
        },
        country (val) {
            if (val) {
                this.$http.post('/9api/country/search-province', { country: this.country }).then(rps => {
                    this.select = rps.data
                })
            } else {
                this.selectValue = null
                this.select = []
                this.$emit('input', null)
                this.$emit('onChange', null)
            }
        }
    },
    data () {
        return {
            select: [],
            selectValue: null,
        }
    },
    methods: {
        SelectChange(data) {
            this.$emit('input', data)
            this.$emit('onChange', data)
        }
    }
}
</script>